<template>
    <transition name="slide-fade" >
      <div>
        <div class="uk-padding uk-background-muted" style="min-height: 75vh;">
            <div class="uk-container uk-container-small">
                <h1 class="uk-heading-line uk-text-center">Financial Reporting Services</h1>

                <div id="preparation-of-financial-statements">
                  <div class="uk-flex uk-flex-middle ">
                    <div class="uk-width-1-3 uk-visible@m"  style="z-index: 3">
                      <img src="../assets/fr1.png" alt="">
                    </div>
                    <div class="uk-width-2-3@m" style="z-index: 2">
                      <div class="uk-card uk-card-default uk-card-body uk-padding " style="margin-left: -15px">
                        <h3 class="">Preparation of Financial Statements</h3>
                        <p>
                          When was the last time someone sat with you and went through
                          the financial statements for your business? Trust FINCOR to provide professional, accurate and complete
                          financial statements in accordance with international standards for your Bank, the Auditors, or your
                          Board.
                        </p>
                        <p>
                          We will also sit with you to explain what the numbers mean, and the opportunities they present
                          to make your business more efficient and profitable.
                        </p>
                      </div>
                    </div>

                  </div>
                  <br><br>
                </div>
                <div id="annual-reports">
                  <div class="uk-flex uk-flex-middle ">
                    <div class="uk-width-2-3@m" style="z-index: 2">
                      <div class="uk-card uk-card-default uk-card-body uk-padding " style="margin-right: -15px">
                        <h3 class="">Annual Reports</h3>
                        <p>
                          We prepare professional annual reports for several agencies each year. We help
                          management to highlight their organization’s achievements, formulate looking ahead statements and
                          provide accountability to key stakeholders. The annual report is also a great marketing tool that allows
                          organisations to communicate with internal and external stakeholders, attract and retain staff and
                          encourage public support.
                        </p>
                        <p>
                          For Non-Governmental Organisations (NGOs) who provide services to the Government, we can also
                          provide reports on actual against budgets for output delivery, help develop cost tracking systems and
                          ensure a robust system of accountability for public funds.
                        </p>
                      </div>
                    </div>
                    <div class="uk-width-1-3   uk-visible@m"  style="z-index: 3">
                      <img src="../assets/fr4.png" alt="">
                    </div>
                  </div>
                  <br><br>
                </div>
                <div id="strata-and-non-profits">
                  <div class="uk-flex uk-flex-middle ">
                    <div class="uk-width-1-3  uk-visible@m"  style="z-index: 3">
                      <img src="../assets/fr1.png" alt="">
                    </div>
                    <div class="uk-width-2-3@m" style="z-index: 2">
                      <div class="uk-card uk-card-default uk-card-body uk-padding " style="margin-left: -15px">
                        <h3 class="">Financial Reporting for Strata Corporations and Non-Profits</h3>
                        <p>
                          Are you part of an organization which
                          handles significant cash resources but you’re not really sure how that money is being spent? FINCOR can
                          help by providing independent third-party reporting for your
                          Strata Corporations, Home
                          Owners Associations, churches,
                          non-profit or other charitable organizations.
                        </p>
                        <p>
                          We can meet with your Committees, Boards, or other
                          stakeholders to explain the performance of the organization and provide other advisory services.
                        </p>
                      </div>
                    </div>

                  </div>
                  <br><br>
                </div>

<!--              <div class=" uk-child-width-1-2@s uk-child-width-1-3@l" uk-grid>
                        <div>
                            <div class="uk-card uk-card-default">
                                <div class="uk-card-media-bottom">
                                    <img src="../assets/fr1.png" alt="">
                                </div>
                                <div class="uk-card-body" style="padding: 10px;">
                                    <h5 class="specHeading uk-text-bold">Preparation of financial statements;</h5>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="uk-card uk-card-default">
                                <div class="uk-card-media-bottom">
                                    <img src="../assets/fr4.png" alt="">
                                </div>
                                <div class="uk-card-body" style="padding: 10px;">
                                    <h5 class="specHeading uk-text-bold">Annual Reports;</h5>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="uk-card uk-card-default">
                                <div class="uk-card-media-bottom">
                                    <img src="../assets/fr3.png" alt="">
                                </div>
                                <div class="uk-card-body" style="padding: 10px;">
                                    <h5 class="specHeading uk-text-bold">Preparation of bank compliance reporting; and</h5>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="uk-card uk-card-default">
                                <div class="uk-card-media-bottom">
                                    <img src="../assets/fr2.png" alt="">
                                </div>
                                <div class="uk-card-body" style="padding: 10px;">
                                    <h5 class="specHeading uk-text-bold">Personal Financials for Immigration.</h5>
                                </div>
                            </div>
                        </div>



                </div>-->
            </div>
        </div>
        <ContactStrip />
      </div>
    </transition>
</template>

<script>
    import ContactStrip from "@/components/parts/ContactStrip.vue";

    export default {
        name: "financialReporting",
      components: {ContactStrip},
      metaInfo: {
        title: ' Financial Reporting Services',
        meta: [{
          content: 'FINCOR provides several reporting services to our clients such as: The preparation of financial statements, annual reports, Preparation of bank compliance reporting and Personal Financials for Immigration.'
        }]
      }
    }
</script>

<style scoped>
  img{
    border-radius: 5px;
  }
</style>